import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip
} from 'react-bootstrap';
import ReactSelect from 'react-select';

const ListOrderComponent = ({
  type,
  setType,
  page,
  propsLimit,
  totalProps,
  setPropsLimit,
  filtersAndSort,
  setFiltersAndSort,
  noSwitch,
  rowsPerPageOptions,
  loading
}) => {
  const [isAsc, setIsAsc] = useState(false);
  const [sortBy, setSortBy] = useState('updated_at');
  const [totalItems, setTotalItems] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [pageIndex, setPageIndex] = useState(page - 1);

  useEffect(() => {
    setPageIndex(page - 1);
    setFrom(propsLimit * pageIndex + 1);
    setTo(propsLimit * page > totalProps ? totalProps : propsLimit * page);
    setTotalItems(totalProps);
  }, [propsLimit, page, totalProps, pageIndex]);

  useEffect(() => {
    setFiltersAndSort(prev => ({
      ...prev,
      sortBy: {
        order: !isAsc ? 'desc' : 'asc',
        prop: sortBy
      }
    }));
  }, [sortBy, isAsc]);

  const displayRange = totalProps > 0 ? `${from}-${to} de ${totalItems}` : '';

  const rowsPerPageOptionsForSelect = rowsPerPageOptions.map(value => ({
    value: value,
    label: value.toString()
  }));

  const sortOptions = [
    { value: 'updated_at', label: 'Última Actualización' },
    { value: 'price', label: 'Precio' },
    { value: 'address', label: 'Dirección' },
    { value: 'operation', label: 'Operación' },
    { value: 'type', label: 'Tipo de Inmueble' },
    { value: 'status', label: 'Estado' }
  ];

  return (
    <>
      <Card className="mb-1 bg-white">
        <Card.Body>
          <Row className="flex-between-center">
            <Col
              sm="auto"
              as={Flex}
              alignItems="center"
              className="mb-2 mb-sm-0"
            >
              <ReactSelect
                value={rowsPerPageOptionsForSelect.find(
                  option => option.value === propsLimit
                )}
                onChange={selectedOption => setPropsLimit(selectedOption.value)}
                options={rowsPerPageOptionsForSelect}
                className="basic-single"
                classNamePrefix="select"
              />
              <h6 className="mb-0 ms-2">
                {loading ? 'Cargando...' : displayRange}
              </h6>
            </Col>

            <Col sm="auto">
              <Row className="gx-2 align-items-center">
                {type !== 'table' && (
                  <Col xs="auto">
                    <Form as={Row} className="gx-2">
                      <Col xs="auto">
                        <small>Ordenar por:</small>
                      </Col>
                      <Col xs="auto" className="w-100">
                        <InputGroup size="sm">
                          <ReactSelect
                            value={sortOptions.find(
                              option =>
                                option.value === filtersAndSort.sortBy.prop
                            )}
                            onChange={selectedOption =>
                              setSortBy(selectedOption.value)
                            }
                            options={sortOptions}
                            className="basic-single"
                            classNamePrefix="select"
                          />
                          <InputGroup.Text
                            as={Button}
                            variant="primary"
                            onClick={() => setIsAsc(!isAsc)}
                          >
                            <FontAwesomeIcon
                              icon={
                                isAsc ? 'sort-amount-up' : 'sort-amount-down'
                              }
                            />
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Form>
                  </Col>
                )}
                {!noSwitch && (
                  <Col xs="12" md="auto" className="pl-0">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip>
                          {type === 'table' ? 'Cartas' : 'Lista'}
                        </Tooltip>
                      }
                    >
                      <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={() =>
                          setType(type === 'cards' ? 'table' : 'cards')
                        }
                        className="w-100"
                        style={{ maxWidth: '348px', marginTop: '1.5rem' }}
                      >
                        <FontAwesomeIcon
                          icon={classNames({
                            th: type === 'table',
                            'list-ul': type === 'cards'
                          })}
                        />
                      </Button>
                    </OverlayTrigger>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

ListOrderComponent.propTypes = {
  type: PropTypes.string.isRequired,
  setType: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  propsLimit: PropTypes.number.isRequired,
  totalProps: PropTypes.number.isRequired,
  setPropsLimit: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired,
  setFiltersAndSort: PropTypes.func.isRequired,
  noSwitch: PropTypes.bool,
  rowsPerPageOptions: PropTypes.array,
  loading: PropTypes.bool.isRequired
};

export default ListOrderComponent;
